import axiosServices from './request';

const ContentApi = axiosServices('contentcenter/v1.0');

export default {
  /** 获取资源分类 */
  listType4Qr: ContentApi('get', 'resourceType/listType4Qr'),
  /** 获取资源列表 */
  listPage4Adviser: ContentApi('get', 'resource/listPage4Adviser'),
  /** 获取资源详情 */
  getDetailById4Resource: ContentApi('get', 'resource/getDetailById')
};